/* Change this file to get your personal Portfolio */

// To change portfolio colors globally go to the  _globalColor.scss file

import emoji from "react-easy-emoji";
import splashAnimation from "./assets/lottie/loadingko"; // Rename to your file name for custom animation

// Splash Screen

const splashScreen = {
  enabled: true, // set false to disable splash screen
  animation: splashAnimation,
  duration: 2000 // Set animation duration as per your animation
};

// Summary And Greeting Section

const illustration = {
  animated: true // Set to false to use static SVG
};

const greeting = {
  username: "Jeric Ricafrente",
  title: "Hi all, I'm Jeric Ricafrente",
  subTitle: emoji(
    "Passionate about Android coding—where every line of code is a step closer to crafting innovative and impactful mobile experiences. 🚀🤖 #AndroidDevLove #SoftwareEngineer"
  ),
  resumeLink:
    "https://drive.google.com/drive/folders/1_7CMUb5a-qzSCWmgFvG28lfzhjpisofq?usp=drive_link", // Set to empty to hide the button
  displayGreeting: true // Set false to hide this section, defaults to true
};

// Social Media Links

const socialMediaLinks = {
  github: "https://github.com/jericricafrente03",
  linkedin: "https://www.linkedin.com/in/jeric-ricafrente-37596527b/",
  gmail: "kyllelance1819@gmail.com",
  facebook: "https://www.facebook.com/kylledylan.ricafrente?mibextid=ZbWKwL",
  // Instagram, Twitter and Kaggle are also supported in the links!
  // To customize icons and social links, tweak src/components/SocialMedia
  display: true // Set true to display this section, defaults to false
};

// Skills Section

const skillsSection = {
  title: "What I do",
  subTitle: "Enthusiastic Software Engineer Eager to Dive into Diverse Technology Stacks.",
  skills: [
    emoji(
      "⚡ Develop highly interactive Android App / User Interfaces for your tv and mobile applications"
    ),
    emoji("⚡ Skilled in Java/Kotlin, Android SDK, UI/UX design, debugging, testing, version control, and committed to ongoing learning in Android development."),
    emoji(
      "⚡ Integration of third party services such as Firebase/ REST API / REALM / XMPP and many more."
    )
  ],

  /* Make Sure to include correct Font Awesome Classname to view your icon
https://fontawesome.com/icons?d=gallery */

  softwareSkills: [
    {
      skillName: "kotlin",
      fontAwesomeClassname: "fab fa-kickstarter"
    },
    {
      skillName: "java",
      fontAwesomeClassname: "fab fa-java"
    },
    {
      skillName: "flutter",
      fontAwesomeClassname: "fab fa-android"
    },
    {
      skillName: "Code Igniter",
      fontAwesomeClassname: "fas fa-fire"
    },
    {
      skillName: "sql-database",
      fontAwesomeClassname: "fas fa-database"
    },
    {
      skillName: "Linux",
      fontAwesomeClassname: "fab fa-linux"
    },
    {
      skillName: "html-5",
      fontAwesomeClassname: "fab fa-html5"
    },
    {
      skillName: "css3",
      fontAwesomeClassname: "fab fa-css3-alt"
    },
    {
      skillName: "JavaScript",
      fontAwesomeClassname: "fab fa-js"
    },
    
  ],
  display: true // Set false to hide this section, defaults to true
};

// Education Section

const educationInfo = {
  display: true, // Set false to hide this section, defaults to true
  schools: [
    {
      schoolName: "International Electronics and Technical Institute,Inc.",
      logo: require("./assets/images/ieti.png"),
      subHeader: "Bachelor of Computer Engineering",
      duration: "June 2016 - August 2021",
      desc: "5 T. Molina, Alabang, Muntinlupa, 1770 Metro Manila",
      descBullets: [
       
      ]
    },
    {
      schoolName: "Lyceum Asia, Inc. ",
      logo: require("./assets/images/stanfordLogo.png"),
      subHeader: "Information Techonology",
      duration: "2010 - 2012",
      desc: "Alabang national road, Muntinlupa city",
      descBullets: []
    }
  ]
};

// Your top 3 proficient stacks/tech experience

const techStack = {
  viewSkillBars: true, //Set it to true to show Proficiency Section
  experience: [
    {
      Stack: "Design UI/UX", //Insert stack or technology you have experience in
      progressPercentage: "90%" //Insert relative proficiency in percentage
    },
    {
      Stack: "Android Programming",
      progressPercentage: "80%"
    },
    {
      Stack: "Backend Programming",
      progressPercentage: "60%"
    }
  ],
  displayCodersrank: false // Set true to display codersrank badges section need to changes your username in src/containers/skillProgress/skillProgress.js:17:62, defaults to false
};

// Work experience section

const workExperiences = {
  display: true, //Set it to true to show workExperiences Section
  experience: [
    {
      role: "Assistant Manager/ Software Engineer",
      company: "Bittel Asia Inc.",
      companylogo: require("./assets/images/b.jpg"),
      date: "August 25 2021 – Present",
      descBullets: [
        "Designing and developing mobile applications for the Android platform using Java or Kotlin programming languages.",
        "Writing clean, efficient, and maintainable code that adheres to best practices and coding standards.",
        "Testing applications for bugs, performance issues, and device compatibility, and troubleshooting and resolving any issues that arise.",
        "Backend Support."
      ]
    },
    {
      role: "Reshipper",
      company: "Lazada Philippines, Inc.",
      companylogo: require("./assets/images/l.jpg"),
      date: "June 2020 – April 2021",
      descBullets: [
        "Changing the product database manually in the system.",
        "Sorting of products based on their size.",
        "Printing of sales invoices."
      ] 
    },
    {
      role: "Data Analyst",
      company: "Lazada Philippines, Inc.",
      companylogo: require("./assets/images/l.jpg"),
      date: "March 2015 – April 2017",
      descBullets: [
        "Creating visualizations, dashboards, and reports to present findings and communicate insights to stakeholders.",
        "Analyzing data using statistical methods and machine learning algorithms to extract insights and identify trends.",
        "Collecting and compiling data from various sources such as databases, spreadsheets, and APIs."
      ] 
    },
    {
      role: "Account Officer",
      company: "Tulay Sa Pagunlad Inc. (TSPI)",
      companylogo: require("./assets/images/tspi.jpg"),
      date: "Jan 2015 – Sep 2015",
      descBullets: [
        "Account Officer typically involves managing client accounts, maintaining relationships with existing clients, and acquiring new customers. ",
        "Were handling financial transactions, prepare reports, and ensure that clients' needs are met.",
        "We analyze financial data, assess creditworthiness, and provide recommendations to clients. "
      ] 
    },
    {
      role: "IT Staff / Web developer",
      company: "FiberGlass Abalos Industiries",
      companylogo: require("./assets/images/letter-a.png"),
      date: "Jan 2015 – Sep 2015",
      descBullets: [
        "Designing and developing mobile applications for the Android platform using Java or Kotlin programming languages.",
        "Writing clean, efficient, and maintainable code that adheres to best practices and coding standards.",
        "Testing applications for bugs, performance issues, and device compatibility, and troubleshooting and resolving any issues that arise."
      ] 
    }
  ]
};

/* Your Open Source Section to View Your Github Pinned Projects
To know how to get github key look at readme.md */

const openSource = {
  showGithubProfile: "true", // Set true or false to show Contact profile using Github, defaults to true
  display: false // Set false to hide this section, defaults to true
};

// Some big projects you have worked on

const bigProjects = {
  title: "Big Projects",
  subtitle: "SOME STARTUPS AND COMPANIES THAT I HELPED TO CREATE THEIR TECH",
  projects: [
    {
      image: require("./assets/images/holidayin.png"),
      projectName: "Holiday Inn Cebu",
      projectDesc: "IPTV Project",
      footerLink: [
        {
          name: "Visit Website",
          url: "https://www.ihg.com/holidayinn/hotels/us/en/cebu/cebcc/hoteldetail"
        }
        //  you can add extra buttons here.
      ]
    },
    {
      image: require("./assets/images/santa.png"),
      projectName: "The Quay Hotel",
      projectDesc: "IPTV Project",
      footerLink: [
        {
          name: "Visit Website",
          url: "https://www.thequayhotel.sg/"
        }
      ]
    }
  ],
  display: true // Set false to hide this section, defaults to true
};

// Achievement Section
// Include certificates, talks etc

const achievementSection = {
  title: emoji("Achievements 🏆 "),
  subtitle:
    "Achievements, Certifications, Award Letters and Some Cool Stuff that I have done !",

  achievementsCards: [
    {
      title: "Cebu Holiday Inn",
      subtitle:
        "IPTV Installation",
      image: require("./assets/images/me.jpg"),
      imageAlt: "HolidayInn",
      footerLink: [
        // {
        //   name: "Certification",
        //   url: "https://drive.google.com/file/d/0B7kazrtMwm5dYkVvNjdNWjNybWJrbndFSHpNY2NFV1p4YmU0/view?usp=sharing"
        // },
        // {
        //   name: "Award Letter",
        //   url: "https://drive.google.com/file/d/0B7kazrtMwm5dekxBTW5hQkg2WXUyR3QzQmR0VERiLXlGRVdF/view?usp=sharing"
        // },
        // {
        //   name: "Google Code-in Blog",
        //   url: "https://opensource.googleblog.com/2019/01/google-code-in-2018-winners.html"
        // }
      ]
    },
    {
      title: "Solaire Resort",
      subtitle:
        "IPTV demo at solaire",
      image: require("./assets/images/soliare.jpg"),
      imageAlt: "Google Assistant Action Logo",
      footerLink: [
        // {
        //   name: "View Google Assistant Action",
        //   url: "https://assistant.google.com/services/a/uid/000000100ee688ee?hl=en"
        // }
      ]
    },

    {
      title: "Shangri-La Plaza",
      subtitle: "IPTV demo at Shangri-La",
      image: require("./assets/images/shang.jpg"),
      imageAlt: "PWA Logo",
      footerLink: [
        // {name: "Certification", url: ""},
        // {
        //   name: "Final Project",
        //   url: "https://pakistan-olx-1.firebaseapp.com/"
        // }
      ]
    }
  ],
  display: true // Set false to hide this section, defaults to true
};

// Blogs Section

const blogSection = {
  title: "Blogs",
  subtitle:
    "With Love for Developing cool stuff, I love to write and teach others what I have learnt.",
  displayMediumBlogs: "true", // Set true to display fetched medium blogs instead of hardcoded ones
  blogs: [
    {
      url: "https://blog.usejournal.com/create-a-google-assistant-action-and-win-a-google-t-shirt-and-cloud-credits-4a8d86d76eae",
      title: "Win a Google Assistant Tshirt and $200 in Google Cloud Credits",
      description:
        "Do you want to win $200 and Google Assistant Tshirt by creating a Google Assistant Action in less then 30 min?"
    },
    {
      url: "https://medium.com/@saadpasta/why-react-is-the-best-5a97563f423e",
      title: "Why REACT is The Best?",
      description:
        "React is a JavaScript library for building User Interface. It is maintained by Facebook and a community of individual developers and companies."
    }
  ],
  display: false // Set false to hide this section, defaults to true
};

// Talks Sections

const talkSection = {
  title: "TALKS",
  subtitle: emoji(
    "I LOVE TO SHARE MY LIMITED KNOWLEDGE AND GET A SPEAKER BADGE 😅"
  ),

  talks: [
    {
      title: "Build Actions For Google Assistant",
      subtitle: "Codelab at GDG DevFest Karachi 2019",
      slides_url: "https://bit.ly/saadpasta-slides",
      event_url: "https://www.facebook.com/events/2339906106275053/"
    }
  ],
  display: false // Set false to hide this section, defaults to true
};

// Podcast Section

const podcastSection = {
  title: emoji("Podcast 🎙️"),
  subtitle: "I LOVE TO TALK ABOUT MYSELF AND TECHNOLOGY",

  // Please Provide with Your Podcast embeded Link
  podcast: [
    "https://anchor.fm/codevcast/embed/episodes/DevStory---Saad-Pasta-from-Karachi--Pakistan-e9givv/a-a15itvo"
  ],
  display: false // Set false to hide this section, defaults to true
};

const contactInfo = {
  title: emoji("Contact Me ☎️"),
  subtitle:
    "Discuss a project or just want to say hi? My Inbox is open for all.",
  number: "+9128499750",
  email_address: "kyllelance1819@gmail.com"
};

// Twitter Section

const twitterDetails = {
  userName: "twitter", //Replace "twitter" with your twitter username without @
  display: false // Set true to display this section, defaults to false
};

const isHireable = false; // Set false if you are not looking for a job. Also isHireable will be display as Open for opportunities: Yes/No in the GitHub footer

export {
  illustration,
  greeting,
  socialMediaLinks,
  splashScreen,
  skillsSection,
  educationInfo,
  techStack,
  workExperiences,
  openSource,
  bigProjects,
  achievementSection,
  blogSection,
  talkSection,
  podcastSection,
  contactInfo,
  twitterDetails,
  isHireable
};
